import React from "react";
import {CheckoutTile} from "../components";
import {useCore} from "../hooks";

export const CheckoutsList: React.FC = () => {
  const { checkouts } = useCore()
  return (
    <div className="w-full h-body  max-w-4xl mx-auto pt-16 flex flex-col">
      <h1 className="text-center font-extrabold text-2xl uppercase mb-4">Vyberte pokladnu</h1>
      <div className="grid grid-cols-2 gap-3 mt-4 px-4 scrollable-y flex-1 pb-8">
        {checkouts?.map(checkout => <CheckoutTile checkout={checkout} key={`checkout-${checkout.id}`} />)}
      </div>
    </div>
  )
}
